import { render, staticRenderFns } from "./FailSign.vue?vue&type=template&id=aef966fc&scoped=true"
import script from "./FailSign.vue?vue&type=script&lang=js"
export * from "./FailSign.vue?vue&type=script&lang=js"
import style0 from "./FailSign.vue?vue&type=style&index=0&id=aef966fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef966fc",
  null
  
)

export default component.exports